import React from 'react';
import { Event } from '../../../../types/calendar';
import { isSameDay } from '../../../../utils/date';
import TimeIndicator from '../TimeIndicator';

interface DayViewProps {
  currentDate: Date;
  events: Event[];
  onSlotClick: (date: Date) => void;
  onEventClick: (event: Event, e: React.MouseEvent) => void;
}

export default function DayView({ currentDate, events, onSlotClick, onEventClick }: DayViewProps) {
  const hours = Array.from({ length: 24 }, (_, i) => i);
  const today = new Date();
  const isToday = isSameDay(currentDate, today);
  const dayEvents = events.filter(event => isSameDay(new Date(event.start), currentDate));

  return (
    <div className="flex flex-col h-[800px]">
      {/* Day header */}
      <div className="grid grid-cols-2 border-b border-gray-200">
        <div className="py-2 text-center text-sm font-medium text-gray-500">
          Hora
        </div>
        <div className={`py-2 text-center ${isToday ? 'bg-blue-50' : ''}`}>
          <div className="text-sm font-medium text-gray-900">
            {currentDate.toLocaleDateString('pt-BR', { weekday: 'long' })}
          </div>
          <div className={`text-sm ${isToday ? 'text-indigo-600 font-semibold' : 'text-gray-500'}`}>
            {currentDate.getDate()}
          </div>
        </div>
      </div>

      {/* Time grid */}
      <div className="flex-1 overflow-y-auto">
        <div className="grid grid-cols-2">
          {/* Time labels */}
          <div className="border-r border-gray-200">
            {hours.map((hour) => (
              <div key={hour} className="h-12 border-b border-gray-200 text-right pr-2">
                <span className="text-xs text-gray-500">
                  {`${hour.toString().padStart(2, '0')}:00`}
                </span>
              </div>
            ))}
          </div>

          {/* Day slots */}
          <div className={`relative ${isToday ? 'bg-blue-50/30' : ''}`}>
            {hours.map((hour) => (
              <div
                key={hour}
                onClick={() => {
                  const date = new Date(currentDate);
                  date.setHours(hour);
                  onSlotClick(date);
                }}
                className="h-12 border-b border-gray-200 hover:bg-gray-50 cursor-pointer relative"
              >
                {/* Events */}
                {dayEvents.map((event) => {
                  const eventStart = new Date(event.start);
                  if (eventStart.getHours() === hour) {
                    return (
                      <div
                        key={event.id}
                        onClick={(e) => onEventClick(event, e)}
                        className="absolute left-0 right-0 mx-1 px-2 py-1 text-xs rounded-lg truncate text-gray-900"
                        style={{ backgroundColor: event.color || '#E0E7FF' }}
                      >
                        {event.title}
                      </div>
                    );
                  }
                  return null;
                })}
              </div>
            ))}

            {/* Current time indicator */}
            {isToday && <TimeIndicator view="day" />}
          </div>
        </div>
      </div>
    </div>
  );
}